import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=1ba3f6f0&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba3f6f0')) {
      api.createRecord('1ba3f6f0', component.options)
    } else {
      api.reload('1ba3f6f0', component.options)
    }
    module.hot.accept("./Devices.vue?vue&type=template&id=1ba3f6f0&", function () {
      api.rerender('1ba3f6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/Devices.vue"
export default component.exports